import React from 'react';

/**
 * Reservation flow progress bar.
 * @param {number} step - current step (1-based)
 * @param {number} total - total steps
 */
export default function ReservationProgressBar({ step, total }) {
  const pct = Math.round((step / total) * 100);

  return (
    <div className="w-full h-1 bg-mono-100">
      <div
        className="h-full bg-orange-500 transition-all duration-300 ease-in-out"
        style={{ width: `${pct}%` }}
      />
    </div>
  );
}
